<template>
<div class="upload-content mt-5">
    <div class="card p-3">
        <component :is="contentType" :data="content" />
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ContentImage from './ContentUpload/ContentImage';
import ContentVideo from './ContentUpload/ContentVideo';
import ContentAudio from './ContentUpload/ContentAudio';
import ContentPDF from './ContentUpload/ContentPDF';
import ContentUndefinedFile from './ContentUpload/ContentUndefinedFile';

export default {
    name: 'ClassContentUpload',
    components: {
        ContentImage,
        ContentVideo,
        ContentAudio,
        ContentPDF,
        ContentUndefinedFile,
    },
    data() {
        return {
            data: [],
            loaded: false,
            files: [],
        };
    },
    computed: {
        ...mapGetters({
            content: 'CLASS_CONTENT',
            language: 'LANGUAGE',
        }),
        contentType() {
            if (this.content.type_file === 'image') return 'ContentImage';
            else if (this.content.mime === 'video/mp4') return 'ContentVideo';
            else if (this.content.mime === 'audio/mpeg') return 'ContentAudio';
            else if (this.content.mime === 'application/pdf') return 'ContentPDF';
            return 'ContentUndefinedFile';
        },
    },
    mounted() {
        this.$emit('contentSubmited');
    },
};
</script>

<style lang="sass" scoped>
.upload-content
    width: 100%
    max-width: 1140px
    margin: 0 auto
</style>
